import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { GlobalVariable } from './../../shared/global';
import 'rxjs/add/operator/toPromise';
import { LocalStorageService } from 'angular-2-local-storage';

@Injectable()

export class PaymentusService {

	private baseApiUrlTest = GlobalVariable.BASE_API_URL;
	private headers = new Headers({ 'Content-Type': 'application/json' });
	private payment_url = this.baseApiUrlTest + 'api/payment/post/payment';
	private barcode_image_url = this.baseApiUrlTest + 'api/payment/download/barcode';
	private get_card = this.baseApiUrlTest + 'api/ManageCard/get/card/detail';
	private get_auth_token = this.baseApiUrlTest + 'api/payment/processor/token'
	private get_auth_token_by_ban = this.baseApiUrlTest + 'api/payment/processor/token/ban'
	private get_payment_profiles = this.baseApiUrlTest + 'api/payment/processor/profiles'
	private get_cards = this.baseApiUrlTest + 'api/ManageCard/get/card/detail';

	constructor(private http: Http, private localStorageService: LocalStorageService) { }

	fetchAuthToken(token: string, paymentType: string) {
		return this.http
			.get(this.get_auth_token + '?token=' + token + '&paymentType=' + paymentType)
			.toPromise()
			.then(res => res.text())
			.catch(this.handleError);
	}

	fetchAuthTokenForBan(ban: string, paymentType: string) {
		return this.http
			.get(this.get_auth_token_by_ban + '?ban=' + ban + '&paymentType=' + paymentType)
			.toPromise()
			.then(res => res.text())
			.catch(this.handleError);
	}

	fetchPaymentProfiles(token: string, force?: boolean) {
		let url = this.get_payment_profiles + '?token=' + token + (force ? '&force=true' : '');
		return this.http
			.get(url)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

	fetchPaymentProfilesForBan(ban: string) {
		return this.http
			.get(this.get_payment_profiles + '?ban=' + ban)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

	getCards(token: Object) {
		return this.http
			.post(this.get_cards, token)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

	paymentPay(card_detail: Object) {
		return this.http
			.post(this.payment_url, card_detail)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

	getCard(token: Object) {
		return this.http
			.post(this.get_card, token)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

	barcodeImage(user_number: Object) {
		return this.http
			.post(this.barcode_image_url, user_number)
			.toPromise()
			.then(res => res.json())
			.catch(this.handleError);
	}

	private handleError(error: any): Promise<any> {
		return Promise.reject(error.message || error);
	}
}



// WEBPACK FOOTER //
// ./src/app/payment/paymentus/paymentus.service.ts